// extracted by mini-css-extract-plugin
export var link = "page-module--link--df38e";
export var main = "page-module--main--3cd60";
export var wrapper = "page-module--wrapper--1d4f7";